export const filterSuperbillClaimProcedure = (procedure) =>
  !procedure?.invoiceId && procedure?.procedure_code;
